import { Navigate } from "react-router-dom";

const UserSubscriptionPage = () => {
  return <Navigate to="/profile?tab=subscription" replace />;
};

export default UserSubscriptionPage;
